<template lang="pug">
  app-dialog(v-model="$_show" header="Создать заявку на оплату" confirm-text="Создать" :confirm-disabled="isNotReady" @confirm="createAdvocatApp" width="756")
    .advocatapp
        v-form(ref="addAppForm" v-model="valid")
          v-autocomplete(
            :items="entries"
            :loading="caseIsLoading"
            :search-input.sync="caseSearch"
            item-text="number"
            item-value="id"
            hide-no-data
            hide-selected
            label="Номер дела"
            placeholder="Начните набирать номер дела"
            outlined
            @change="selectCaseNumber")

          div(v-if="form.caseId!=''")
              app-text-field(v-model="form.caseType" label="Тип дела" readonly)
              app-text-field(v-model="form.caseCourt" label="Наименование суда/судебного участка" readonly)
              app-text-field(v-model="form.caseJudge" label="Судья" readonly)
              app-select(v-model="form.caseMemberId" :items="caseMemberList" label="ФИО подзащитного" item-text="name" item-value="id" :rules="[rules.required]")
          app-text-field(v-model="form.orderNumber" label="Номер ордера адвоката" :rules="[rules.required]")
          app-date-picker(v-model="form.orderDate" :viewFormat="'DD.MM.YYYY'" label="Дата выдачи ордера адвоката" :rules="[rules.required]")
          app-text-field(v-model="form.orderIssuer" label="Кем выдан ордер адвоката" :rules="[rules.required]")

</template>

<script>
import moment from 'moment'
import { AppDialogToggable } from '@/components'
import { specialistService } from '@/_services'
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [AppDialogToggable, $_validate_rules],
  data () {
    const defaultForm = Object.freeze({
      caseId: '',
      caseMemberId: '',
      caseType: '',
      caseCourt: '',
      caseJudge: '',
      orderNumber: '',
      orderDate: moment().format('YYYY-MM-DD'),
      orderIssuer: ''
    })

    return {
      valid: false,
      form: Object.assign({}, defaultForm),
      caseMembers: [],
      entries: [],
      caseEntity: null,
      caseIsLoading: false,
      caseSearch: null,
      defaultForm
    }
  },
  methods: {
    selectCaseNumber (val) {
      specialistService.getCase(val)
      .then(data => {
          if(data) {
              this.form.caseId=data.id
              this.form.caseType=data.caseCategory? data.caseCategory.title : ""
              this.form.caseCourt=data.judge.court.name
              this.form.caseJudge=data.judge.lastName +" "+ data.judge.firstName +" "+ data.judge.middleName
              this.caseMembers=data.caseMembers
              if(this.caseMemberList) this.form.caseMemberId=this.caseMemberList[0].id
          } else {
              this.form.caseId=this.form.caseType=this.form.caseCourt=this.form.caseJudge=""
              this.caseMembers=[]
          }
      })
    },
    createAdvocatApp() {
      if (this.$refs.addAppForm.validate()) {
         this.form.orderDate=moment(this.form.orderDate).format('YYYY-MM-DD HH:mm')
         this.$store.dispatch('advocat/CREATE_APP', this.form).then(data => {
           this.$router.push({name: 'AdvocatAppDetail', params: {appId: data.id, addItem: true}})
         })
      }
    },
  },
  computed: {
    caseMemberList () {
      return this.caseMembers.map(function(mem) {
        return {"id":mem.id, "name": mem.persona.personaType.value==1?mem.persona.orgName:mem.persona.name};
      })
    },
    isNotReady () {
      if(!this.valid) return true
      return this.form.caseId === ""
    },
  },
  watch: {
    caseSearch (val) {

      this.entries=[]
      this.caseIsLoading = true

      specialistService.findCases(val)
      .then(data => {
          if(data.length > 0)
            this.entries = data
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => (this.caseIsLoading = false))
    },
  },
}
</script>

<style lang="scss" scoped>

</style>

